import { useI18n, type Lang } from '../lib/i18n'

/**
 * Flags drawn rather than emoji: flag emoji do not render on Windows, which
 * would leave a pair of grey letter boxes where the control should be.
 */
export function LangToggle() {
  const { lang, setLang, t } = useI18n()

  return (
    <div
      role="radiogroup"
      aria-label={t.language}
      className="flex items-center gap-0.5 rounded-full border p-0.5"
      style={{ borderColor: 'var(--border)' }}
    >
      <FlagButton code="en" active={lang === 'en'} onSelect={setLang} label="English" />
      <FlagButton code="pt" active={lang === 'pt'} onSelect={setLang} label="Português" />
    </div>
  )
}

function FlagButton({
  code,
  active,
  label,
  onSelect,
}: {
  code: Lang
  active: boolean
  label: string
  onSelect: (l: Lang) => void
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      aria-label={label}
      title={label}
      onClick={() => onSelect(code)}
      className="grid size-7 place-items-center rounded-full transition-opacity"
      style={{
        opacity: active ? 1 : 0.4,
        background: active ? 'var(--surface-2)' : 'transparent',
      }}
    >
      {code === 'en' ? <UnionJack /> : <PortugalFlag />}
    </button>
  )
}

function UnionJack() {
  return (
    <svg width="19" height="13" viewBox="0 0 60 40" aria-hidden>
      <clipPath id="uk-clip">
        <rect width="60" height="40" rx="2" />
      </clipPath>
      <g clipPath="url(#uk-clip)">
        <rect width="60" height="40" fill="#012169" />
        <path d="M0 0 L60 40 M60 0 L0 40" stroke="#FFF" strokeWidth="8" />
        <path d="M0 0 L60 40 M60 0 L0 40" stroke="#C8102E" strokeWidth="4" />
        <path d="M30 0 V40 M0 20 H60" stroke="#FFF" strokeWidth="13" />
        <path d="M30 0 V40 M0 20 H60" stroke="#C8102E" strokeWidth="8" />
      </g>
    </svg>
  )
}

function PortugalFlag() {
  return (
    <svg width="19" height="13" viewBox="0 0 60 40" aria-hidden>
      <clipPath id="pt-clip">
        <rect width="60" height="40" rx="2" />
      </clipPath>
      <g clipPath="url(#pt-clip)">
        <rect width="60" height="40" fill="#DA291C" />
        <rect width="24" height="40" fill="#046A38" />
        <circle cx="24" cy="20" r="8.5" fill="#FFE900" />
        <circle cx="24" cy="20" r="8.5" fill="none" stroke="#DA291C" strokeWidth="1.2" />
        <path d="M24 13.5 a6.5 6.5 0 0 1 0 13 a6.5 6.5 0 0 1 0 -13" fill="#DA291C" />
        <path d="M24 15.5 a4.5 4.5 0 0 1 0 9 a4.5 4.5 0 0 1 0 -9" fill="#FFF" />
      </g>
    </svg>
  )
}
